import track from './track';
import stat from './stat';
import report from './report';
import transactions from './transactions';

export default {
  namespaced: true,
  modules: { track, stat, report, transactions }
};